import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name user-star
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOC41IDE1SDdhNCA0IDAgMCAwLTQgNHYyIiAvPgogIDxwYXRoIGQ9Ik0xNi41IDEyLjkwM2EuMjI5LjIyOSAwIDAgMSAuNDEgMGwuOTk3IDIuMDIyYS45Mi45MiAwIDAgMCAuNjkuNTAxbDIuMjMuMzI2YS4yMjkuMjI5IDAgMCAxIC4xMjcuMzkybC0xLjYxMyAxLjU3YS45Mi45MiAwIDAgMC0uMjY0LjgxMmwuMzgxIDIuMjJhLjIyOS4yMjkgMCAwIDEtLjMzMy4yNDFMMTcuMTMgMTkuOTRhLjkyLjkyIDAgMCAwLS44NTMgMGwtMS45OTMgMS4wNDhhLjIyOS4yMjkgMCAwIDEtLjMzMy0uMjQybC4zOC0yLjIyYS45Mi45MiAwIDAgMC0uMjY0LS44MWwtMS42MTMtMS41NzFhLjIyOS4yMjkgMCAwIDEgLjEyNy0uMzkybDIuMjMtLjMyNmEuOTIuOTIgMCAwIDAgLjY5LS41MDF6IiAvPgogIDxjaXJjbGUgY3g9IjEwIiBjeT0iNyIgcj0iNCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/user-star
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const UserStar: IconNode = [
  ['path', { d: 'M8.5 15H7a4 4 0 0 0-4 4v2' }],
  [
    'path',
    {
      d: 'M16.5 12.903a.229.229 0 0 1 .41 0l.997 2.022a.92.92 0 0 0 .69.501l2.23.326a.229.229 0 0 1 .127.392l-1.613 1.57a.92.92 0 0 0-.264.812l.381 2.22a.229.229 0 0 1-.333.241L17.13 19.94a.92.92 0 0 0-.853 0l-1.993 1.048a.229.229 0 0 1-.333-.242l.38-2.22a.92.92 0 0 0-.264-.81l-1.613-1.571a.229.229 0 0 1 .127-.392l2.23-.326a.92.92 0 0 0 .69-.501z',
    },
  ],
  ['circle', { cx: '10', cy: '7', r: '4' }],
];

export default UserStar;
